import data from "../utils/datasss.json"
export const fetchData=data

export  const youtubeOptions={
    method: 'GET',
    headers: {
        'X-RapidAPI-Key': '4e39143e6amsh29d89ff5569dc20p1f74d3jsnabf05e28be7a',
        'X-RapidAPI-Host': 'youtube-search-and-download.p.rapidapi.com'
    }
}

export const fetchDatas = async (url, options) => {
    const res = await fetch(url, options);
    const data = await res.json();

    return data;
};